import { Component } from '@angular/core';

@Component({
  selector: 'app-announcement-bar',
  templateUrl: './announcement-bar.component.html',
  styles: [`
    .announcement-bar {
      background-color: #437eeb;
      color: #ffffff;
      padding: 12px 0;
      font-weight: 600;
      letter-spacing: 0.3px;
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
    }
    .announcement-bar a {
      color: #ffffff;
      text-decoration: none;
      display: inline-block;
      padding-left: 100%;
      animation: announcement-scroll 25s linear infinite;
    }
    .announcement-bar a:hover {
      text-decoration: underline;
    }
    @keyframes announcement-scroll {
      from { transform: translateX(0); }
      to { transform: translateX(-100%); }
    }
    @media (prefers-reduced-motion: reduce) {
      .announcement-bar a {
        animation: none;
        padding-left: 0;
      }
      .announcement-bar { text-align: center; }
    }
  `]
})
export class AnnouncementBarComponent {
  announcement = 'Digital Alpha Invests in North Texas Fiber Expansion';
  cta = 'Click to Read More';
  href = 'https://www.prnewswire.com/news-releases/digital-alpha-fuels-major-fiber-infrastructure-expansion-in-north-texas-with-strategic-investment-in-sprocket-networks-302557611.html';
}
